import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-token-input',
  templateUrl: './token-input.component.html',
  styleUrl: './token-input.component.scss',
  standalone: false
})
export class TokenInputComponent {
  token:string = '';
  constructor(private popoverController: PopoverController){}

  saveToken(token:string){
    this.popoverController.dismiss({token});
  }
  accept(){
    this.saveToken(this.token);
  }
}
